import { render, staticRenderFns } from "./PaidService.vue?vue&type=template&id=8b6be778&"
import script from "./PaidService.vue?vue&type=script&lang=js&"
export * from "./PaidService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports